import { Fragment } from 'react';
import { Col, Row } from 'react-bootstrap';
import ErrorLabel from '../../Reusable/ErrorLabel';
import InputField from '../../Reusable/InputField';
import { formatNotificationMessage } from './password-utils';

const PasswordChangeFields = (props) => {
  const {
      newPassword,
      confirmNewPassword,
      t,
      errors,
      setErrors,
      onChangeHandler,
    } = props || {},
    { Placeholders, Tooltips } = t || {};
  const tooltipText = formatNotificationMessage(Tooltips?.passwordRule, '%s');

  return (
    <Fragment>
      <Row>
        <Col>
          <InputField
            id="newPassword"
            name="newPassword"
            type="password"
            placeholder={Placeholders.newPassword}
            value={newPassword}
            onChange={onChangeHandler}
            error={errors}
            errorsHandler={setErrors}
            required
            tooltipText={tooltipText}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputField
            id="confirmNewPassword"
            name="confirmNewPassword"
            type="password"
            placeholder={Placeholders.confirmNewPassword}
            value={confirmNewPassword}
            onChange={onChangeHandler}
            error={errors}
            errorsHandler={setErrors}
            required
          />
        </Col>
        <ErrorLabel error={errors['passwordAndConfirmPasswordMatch']} />
      </Row>
    </Fragment>
  );
};

export default PasswordChangeFields;
